import { z } from 'zod';

export enum ContractStatus {
  Active = 'active',
  Inactive = 'inactive',
  ExpiringSoon = 'expiring-soon',
}

export const ContractStatusSchema = z.nativeEnum(ContractStatus);
export type ContractStatusType = z.infer<typeof ContractStatusSchema>;
